<template>
    <circle-progress
        :class="percent > 1000 ? 'k' : ''"
        :percent="percent > 1000 ? Math.round(percent / 1000) : percent"
        fill-color="#f68e56"
        :empty-color="percent > 100 ? '#f68e56' : '#115370'"
        :show-percent="true"
    />
</template>

<script>
    import CircleProgress from 'vue3-circle-progress';

    export default {
        name: 'CircleProgressBar',
        components: { CircleProgress },
        props: {
            percent: {
                type: Number,
                default: 0,
            },
            suffix: {
                type: String,
                default: '',
            },
        },
    }
</script>

<style lang="scss">
    @import "~bootstrap/scss/vendor/rfs";
    @import '../../scss/variables';

    .vue3-circular-progressbar {
        .current-counter {
            @include font-size(50px);
            font-family: 'Arial Black', sans-serif;
            color: #f68e56;
        }
        &.percent {
            .current-counter {
                &::after {
                    content: '%';
                }
            }
        }
        &.k {
            .current-counter {
                &::after {
                    content: 'k';
                }
            }
        }
    }
</style>
